module.exports = __webpack_public_path__ + "img/audio_thumbnail_albert.d128afb4.png";